import test from './components/test';
import whatGraphic from './components/whatGraphic';
import { faqTabs, faqAccordion } from './components/faq';
import recruitInfoTabs from './components/recruitInfoTabs';
import { cardStacking } from './components/cardStacking';
import projectBg from './components/projectBg';
import benefit from './components/benefit';
import environmentgallery from './components/environmentgallery';
import spscrollable from './components/spscrollable';
import formSettings from './components/formSettings';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    benefit();
    environmentgallery();
    whatGraphic();
    faqTabs();
    faqAccordion();
    recruitInfoTabs();
    cardStacking();
    // resizeCards();
    projectBg();
    spscrollable();
    formSettings();
  },
  false
);

window.addEventListener('resize', () => {
  cardStacking();
  // resizeCards();
});
